import * as Tone from 'tone';
import Envelope from './Envelope';
import LiveState from './LiveState';
class Clip {
    constructor() {
        this.state = new Tone.StateTimeline();
        /**
         *  Represents the yellow 'loop' button in detail view.
         */
        this.loop = false;
        /**
         *  This setting is not represented in the Ableton Live UI.
         *  When loop is set to true;
         *    - loopStart is the position of your loop start flag
         *    - use this value as loop start position, but NOT as start position for playback. For that, we also need to take StartRelative into account.
         *  When loop is set to false;
         *    - loopStart is the position of your start marker.
         *    - use this value as start position for playback. StartRelative should be 0.
         */
        this._loopStart = 0;
        /**
         *  This setting is not represented in the Ableton Live UI.
         *  When loop is set to true;
         *    - loopEnd is the position of your loop end flag
         *    - use this value as loop end position, the OutMarker is not being used at all. Clip should keep playing forever.
         *  When loop is set to false;
         *    - loopEnd is the position of your OutMarker.
         *    - use this value as end position for playback. Value is the same as OutMarker.
         */
        this._loopEnd = 0;
        /**
         *  This setting is not represented in the Ableton Live UI.
         *  When loop is set to true;
         *    - difference (in beats) between your start marker and the loop start flag. When the clip starts playing before the loop start marker, this value will be negative.
         *  When loop is set to false;
         *    - this value should not be used
         */
        this.startRelative = 0;
        /**
         *  The position (in beats) of the OutMarker in the Detail View.
         *  Will be used when loop is false.
         */
        this.outMarker = 0;
        /**
         *  This value is the position (in beats) of the Loop Start marker when loop is false.
         */
        this.hiddenLoopStart = 0;
        /**
         *  This value is the position (in beats) of the Loop End marker when loop is false.
         */
        this.hiddenLoopEnd = 0;
        this._loopLength = null;
        this.launchmode = 'trigger';
        this.quantization = 'global';
        this.clipSlot = null;
        this.envelopes = [];
        this.loop = defaults.loop;
        this.loopStart = defaults.loopStart;
        this.loopEnd = defaults.loopEnd;
        this.startRelative = defaults.startRelative;
        this.outMarker = 0;
        this.hiddenLoopStart = defaults.hiddenLoopStart;
        this.hiddenLoopEnd = defaults.hiddenLoopEnd.toSeconds();
        this.launchmode = defaults.launchmode;
        this.quantization = defaults.quantization;
    }
    get loopStart() {
        return Tone.TransportTime(this._loopStart, 'i');
    }
    set loopStart(loopStart) {
        this._loopStart = Tone.TransportTime(loopStart).toTicks();
    }
    get loopEnd() {
        return Tone.TransportTime(this._loopEnd, 'i');
    }
    set loopEnd(loopEnd) {
        this._loopEnd = Tone.TransportTime(loopEnd).toTicks();
    }
    getStateAtTime(time) {
        return this.state.getValueAtTime(time);
    }
    automation(object, parameter, envelopes) {
        const target = this.getTrack().getAutomationManager().getTarget(object, parameter);
        if (target === undefined) {
            throw Error(`${object} ${parameter} is not automatable`);
        }
        for (const env of this.envelopes) {
            if (env.target === target) {
                throw Error(`${object} ${parameter} is already automated`);
            }
        }
        const envelope = new Envelope(target, envelopes, this);
        this.envelopes.push(envelope);
    }
    start(time) {
        if (Tone.Transport.state === 'stopped') {
            Tone.Transport.start();
        }
        this.clipSlot.clipStarted(this, time);
        this.state.setStateAtTime('started', Tone.Time(time).toSeconds());
        for (const envelope of this.envelopes) {
            envelope.start(Tone.TransportTime(time));
        }
    }
    fire() {
        if (Tone.getContext().transport.state === 'stopped') {
            Tone.getContext().transport.start();
        }
        const now = Tone.getContext().now();
        const actionTime = this.getQuantizedTime(now);
        this.start(actionTime);
        this.clipSlot.clipFired(this, Tone.now());
        return this;
    }
    getQuantizedTime(time) {
        const clipQuantization = this.quantization === 'global'
            ? LiveState.GlobalQuantization
            : this.quantization;
        if (clipQuantization === 'none') {
            return time;
        }
        const actionTime = Tone.Time(time);
        const quantizedTime = Tone.Time(actionTime.toSeconds() + actionTime.quantize(clipQuantization));
        if (quantizedTime.toSeconds() <= Tone.getContext().now()) {
            const quantizationTime = Tone.Time(clipQuantization).toSeconds();
            return Tone.Time(actionTime.toSeconds() + quantizationTime).toSeconds();
        }
        return actionTime.toSeconds();
    }
    stop(time) {
        for (const envelope of this.envelopes) {
            envelope.stop(time);
        }
    }
    getTrack() {
        return this.clipSlot.getTrack();
    }
}
const defaults = {
    loop: true,
    loopStart: Tone.TransportTime(0, 'i'),
    loopEnd: Tone.TransportTime('1m'),
    startRelative: 0,
    hiddenLoopStart: 0,
    hiddenLoopEnd: Tone.TransportTime('1m'),
    launchmode: 'trigger',
    quantization: 'global'
};
export default Clip;
//# sourceMappingURL=Clip.js.map